import React, {useEffect, useState} from "react";
import UserCard from "./UserCard";
import styled from "@emotion/styled";
import Span from "@jumbo/shared/Span";
import {axios_tenant} from "../../../axios";
import {Card, CircularProgress, Typography} from "@mui/material";
import Stack from "@mui/material/Stack";

const TenantUsersList = ({checked, loading, searchFilter, searchQuery}) => {

    const { active, deactivated, pending } = checked;
    const [userData, setUserData] = useState([]);
    const [appData, setAppData] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(true);

    useEffect(() => {
      if (!loading) {
        getUserData();
        getActiveApps();
      }

    }, [loading]);

    const getUserData = () => {
        axios_tenant
        .get("/user/fetchUserData")
            .then(res => {
                setUserData(res.data.data.userResults);
            })
            .catch(err => {
            }).finally(() => {
                setLoadingUsers(false);
            });
    };
    const getActiveApps = () => {
            axios_tenant
            .get("/apps/activeApps")
                .then(res => {
                    setAppData(res.data);
                })
                .catch(err => {
                });
        };
    const Item = styled(Span)(({ theme }) => ({
        padding: theme.spacing(0, 1)
    }));

    const filterData = (user) =>{  
    // 🔹 Status filter
    const statusMatch = (active && user.status === "active") || (deactivated && user.status === "deactivated") || (pending && user.status === "pending");

    if (!statusMatch) return false;

    // 🔹 Search filter
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase().trim(); 

    if (searchFilter === "all") {
        return (
            (user.first_name || "").toLowerCase().includes(query) ||
            (user.last_name || "").toLowerCase().includes(query) || // Users
            (`${user.first_name || ""} ${user.last_name || ""}`).toLowerCase().includes(query)||
            (user.mail || "").toLowerCase().includes(query) || // Email
            (user.status || "").toLowerCase().includes(query) || // Status 
            (user.apps || "").toLowerCase().includes(query) ||
            (user.role || "").toLowerCase().includes(query) // Role
                 
        );
    }
    
    if (searchFilter === "users") {
        return (
            (user.first_name || "").toLowerCase().includes(query) ||
            (user.last_name || "").toLowerCase().includes(query) ||
            (`${user.first_name || ""} ${user.last_name || ""}`).toLowerCase().includes(query)
        );
    }
    
    if (searchFilter === "email") {
        return (user.mail || "").toLowerCase().includes(query);
    }
    
    if (searchFilter === "status") {
        return (user.status || "").toLowerCase().includes(query);
    }
    if (searchFilter === "role") {
        return (user.role || "").toLowerCase().includes(query);
    }
    
};

const filteredUsers = userData.filter((user) => filterData(user));

    return (
        <React.Fragment>
            <Card sx={{ mb: 1 }} variant={"outlined"}>
                <Stack direction={"row"} alignItems={"center"}  sx={{ p: theme => theme.spacing(1, 1) }}>
                    <Item
                        sx={{
                            flex: { xs: 1, md: "0 1 20%", lg: "0 1 20%" },
                            alignSelf: "flex-start",
                            flexBasis: { md: "20%", lg: "20%" },
                            display: { xs: "none", md: "block" },
                        }}
                    >
                        <Typography variant={"h2"} mt={1} lineHeight={1.25}>
                            Users
                        </Typography>
                    </Item>

                    <Item
                        sx={{
                            flex: { xs: 1, md: "0 1 15%", lg: "0 1 15%" },
                            alignSelf: "flex-start",
                            flexBasis: { md: "15%", lg: "15%" }  ,
                            display: { xs: "none", md: "block" },
                        }}
                    >
                        <Typography variant={"h2"} mt={1} lineHeight={1.25}>
                            Role
                        </Typography>
                    </Item>

                    <Item
                        sx={{
                            flex: { xs: 1, md: "0 1 25%", lg: "0 1 25%" },
                            alignSelf: "flex-start",
                            flexBasis: { md: "25%", lg: "25%" } ,
                            display: { xs: "none", md: "block" },
                        }}
                    >
                        <Typography variant={"h2"} mt={1} lineHeight={1.25}>
                            Email
                        </Typography>
                    </Item>

                    <Item
                        sx={{
                            flex: { xs: 1, md: "0 1 15%", lg: "0 1 15%" },
                            alignSelf: "flex-start",
                            flexBasis: { md: "15%", lg: "15%" } ,
                            display: { xs: "none", md: "block" },
                        }}
                    >
                        <Typography variant={"h2"} mt={1} lineHeight={1.25}>
                            Status
                        </Typography>
                    </Item>
                    
                    <Item
                        sx={{
                            flex: { xs: 1, md: "0 1 15%", lg: "0 1 15%" },
                            alignSelf: "flex-start",
                            flexBasis: { md: "15%", lg: "15%" },
                            display: { xs: "none", md: "block" },
                        }}
                    >
                        <Typography variant={"h2"} mt={1} lineHeight={1.25}>
                            Authorized Apps
                        </Typography>
                    </Item>

                    <Item
                        sx={{
                            flex: { xs: 1, md: "0 1 10%", lg: "0 1 10%" },
                            alignSelf: "flex-start",
                            flexBasis: { md: "10%", lg: "10%" },
                            display: { xs: "none", md: "block" },
                            pl: 3,
                        }}
                    >
                        <Typography variant={"h2"} mt={1} lineHeight={1.25}>
                            Action
                        </Typography>
                    </Item>
                </Stack>
            </Card>

            {loadingUsers ? <CircularProgress size={30} sx={{ color: "blue", display: "flex", mx: "auto" , mt: 2 }}  /> : 
            (filteredUsers.length > 0 ? (
                filteredUsers.map((user) => <UserCard user={user} key={user.personid} getUserData={getUserData} allApps={appData} />)
            ) : (
                <Typography align="center" mt={2}>
                    No user found.
                </Typography>
            ))}
              </React.Fragment>
    );
};

export default TenantUsersList;